// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, 
    IconLayoutKanban, IconMail, IconCalendar, 
    IconNfc,
    IconLetterA,
    IconBookmark ,
    IconUsersGroup
} from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const professeurs = {
    id: 'professeur',
    title: ["K. ", <FormattedMessage id="gestion_professeurs" />],
    type: 'group',
    icon: <IconUsersGroup />, // Use a valid icon component here
   /*  children: [
        {
            id: 'proffeurs_',
            title:  <FormattedMessage id="collapse" />,
            type: 'collapse',
            icon: IconLetterA, */
            children: [
        
                {
                    id: 'grade_prof',
                    title: ["1. ", <FormattedMessage id="enregistrer_grade_professeur" />],
                    type: 'item',
                    url: '/professor/GradesProfesseurs'
                },
                {
                    id: 'niveau_prof',
                    title: ["2. ", <FormattedMessage id="enregistrer_niveau_etude" />],
                    type: 'item',
                    url: '/professor/NiveauProfesseurs'
                },
                {
                    id: 'domaineRecherche',
                    title: ["3. ",<FormattedMessage id="enregistrer_domaineRecherche" />],
                    type: 'item',
                    url: '/professor/DomaineRecherche'
                },

                {
                    id: 'categorias_travalleurs1',
                    title: ["4. ",<FormattedMessage id="categorias_travalleurs" />],
                    type: 'item',
                    url: '/professor/CategoriasTravailleurs'
                },

                {
                    id: 'enregistrerProf',
                    title: ["5. ", <FormattedMessage id="enregistrerProfesseur" />],
                    type: 'item',
                    url: '/professor/NewProf'
                },

                {
                    id: 'listProf1',
                    title: ["6. ", <FormattedMessage id="listProf" />],
                    type: 'item',
                    url: '/professor/ListeGeneralProfesseurs'
                },

                {
                    id: 'afecterCours',
                    title: ["7. ", <FormattedMessage id="afectercour_a_professeur" />],
                    type: 'item',
                    url: '/professor/AfectacaoCours'
                },

                {
                    id: 'examen_choixMultiple_automatique1',
                    title: ["8. ", <FormattedMessage id="examen_choixMultiple_automatique" />],
                    type: 'item',
                    url: '/professor/ExamensAChoixMultiplesAutomatiques'
                },

                {
                    id: 'resultats_examens_automatiques1',
                    title: ["9. ", <FormattedMessage id="resultats_examens_automatiques" />],
                    type: 'item',
                    url: '#'
                },

                {
                    id: 'horarios1',
                    title: ["10. ", <FormattedMessage id="horarios_em_grafico" />],
                    type: 'item',
                    url:  '/professor/HorarioDoProfesseor'
                },

            ]
      //  }]
        
};

export default professeurs;
